export const triggerCheckoutFailedEvent = () => {
  const failEvent = new Event("checkout_failed");
  document.dispatchEvent(failEvent);
};
